<template>
    <div v-if="warningModal">
        <div
             id="modal-logout-warning"
             class="modal d-block modal-logout-warning"
             tabindex="-1"
             role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Are you still with us?</h5>
                    </div>
                    <div class="modal-body" id="phone_email_info">
                        <div class="alert alert-danger">
                            Session will be automatically ended in {{ idleDiff }} additional minutes if no activity is observed.
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="closeWarningModal()" >Continue Session</button>
                        <button type="button" class="btn btn-secondary" @click="logoutUser">Log Off</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal_overlay"></div>
    </div>
</template>

<style>
.modal_overlay{
    position: absolute;
    top:0px;
    left:0px;
    width: 100%;
    height: 100%;
    background: black;
    opacity: .2;
    z-index: 100;
}
.modal-logout-warning {
}
</style>

<script>
    export default {
        name: "AutoLogout",
        props: ['idleWarning', 'idleLogout', 'idleDiff'],
        data: function() {
            return {
                events: ['click','mousemove','mousedown','scroll','keypress','load'],
                warningTimer: null,
                logoutTimer: null,
                warningModal: false
            }
        },
        mounted() {
            this.events.forEach(function (event) {
                window.addEventListener(event, this.resetTimer);
            }, this);
            this.setTimers();
            // quick test for logging:
            // this.$http.post('/api/user-auto-logout-log');
            this.updateActiveUser();
        },
        destroyed() {
            this.events.forEach(function (event) {
                window.removeEventListener(event, this.resetTimer);
            }, this);
            this.resetTimer();
        },
        methods: {
            setTimers: function() {
                this.warningTimer = setTimeout(this.warningMessage, this.idleWarning * 60 * 1000);
                this.logoutTimer = setTimeout(this.logAndAutoLogout, this.idleLogout * 60 * 1000);
            },
            updateActiveUser:  function() {
                setInterval(() => {
                    var timeRemaining = this.idleLogout * 60 * 1000 - this.logoutTimer;
                    this.$http.post('/api/update-active-user', {
                        time_remaining: timeRemaining,
                    });
                }, 10000);
            },
            warningMessage: function() {
                this.warningModal = true;
            },
            logAndAutoLogout: function() {
                this.$http.post('/api/user-auto-logout-log').then(function () {
                    window.location.href = '/login';
                });
            },
            logoutUser: async function () {
                // document.getElementById('logout-form').submit();

                try {
                    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
                    await fetch('/logout', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-TOKEN': csrfToken,
                        },
                        body: JSON.stringify({})
                    });
                    window.location.href = '/login';
                } catch (error) {
                    console.error('Logout failed', error);
                }
            },
            resetTimer: function() {
                clearTimeout(this.warningTimer);
                clearTimeout(this.logoutTimer);
                this.setTimers();
            },
            closeWarningModal: function() {
                this.warningModal = false;
            }
        }
    }
</script>
